export default "__VITE_ASSET__7d273c3b__"